/**
 * Utility: pascalCase
 */

/**
 * Split a string into normalized lowercase words.
 *
 * Examples:
 *   words('ampf-blue')       -> ['ampf', 'blue']
 *   words('dark_mint')       -> ['dark', 'mint']
 *   words('midnight blue')   -> ['midnight', 'blue']
 */
export const words = (str: string): string[] => str
    .replace(/[A-Z]+|[0-9]+/g, x => `.${x.toLowerCase()}`)
    .replace(/[^a-z0-9]+/g, '.')
    .split('.')
    .filter(Boolean)

/**
 * Convert a string to PascalCase.
 *
 * Examples:
 *   pascalCase('ampf-blue')     -> 'AmpfBlue'
 *   pascalCase('dark_mint')     -> 'DarkMint'
 */
export const pascalCase = (str: string): string => words(str)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join('')
